import { fetchApi } from '@/config/axiosSetting';
import {
  GetFileInsuranceQueryParamsType,
  GetFileInsuranceQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/getFileInsurance/getFileInsuranceQuery.type';

export const getFileInsuranceFunction = (
  params: GetFileInsuranceQueryParamsType,
): Promise<GetFileInsuranceQueryResponseType> => {
  return fetchApi.get(`file_information/${params.id}/insurance_information/`, {
    params,
  });
};
